import { AdditionalInfoModalOptions } from '@hb/domain/additional-info.model';

import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import { ModalContent } from '@ap/modal';
import { ApContentModule } from '@ap/content';
import { ApAnalyticsModule } from '@ap/analytics';
import { ApButtonComponent } from '@ap/button';

@Component({
    selector: 'additional-info-modal',
    templateUrl: './additional-info-modal.component.html',
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [ApContentModule, ApAnalyticsModule, ApButtonComponent]
})
export class AdditionalInfoModalComponent extends ModalContent<AdditionalInfoModalOptions> {}
